var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".datePicker[data-v-50fccb98] {\n  width: 100% !important;\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _vue2Datepicker = require("vue2-datepicker");

var _vue2Datepicker2 = _interopRequireDefault(_vue2Datepicker);

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { DatePicker: _vue2Datepicker2.default },
  props: ["merchants", "pending_settlement_url", "submit_url"],
  data: function data() {
    return {
      merchantList: [],
      date_range: null,
      merchant_id: null,
      pendingItems: [],
      isCheckAll: false,
      selectedItems: []
    };
  },
  mounted: function mounted() {
    this.merchantList = JSON.parse(this.merchants);
  },

  methods: {
    applyFilter: function applyFilter() {
      this.date_range = null;
    },

    fetchSettlementItems: function fetchSettlementItems() {
      var _this = this;

      if (this.merchant_id == null || this.merchant_id == "" || this.date_range == null || this.date_range == ["", ""]) {
        return;
      } else {
        _axios2.default.post(this.pending_settlement_url, {
          merchant_id: this.merchant_id,
          date_range: this.date_range
        }).then(function (res) {
          if (res.status == 200) {
            _this.pendingItems = res.data.items;
          }
        });
      }
    },

    checkAll: function checkAll() {
      this.isCheckAll = !this.isCheckAll;
      this.selectedItems = [];
      if (this.isCheckAll) {
        for (var key in this.pendingItems) {
          this.selectedItems.push(this.pendingItems[key]);
        }
      }
    },

    updateCheckAll: function updateCheckAll() {
      if (this.pendingItems.length == this.selectedItems.length) {
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
      }
    },

    processSettlement: function processSettlement() {
      var confirmSubmit = confirm("Are you sure?");
      if (!confirmSubmit) {
        return;
      } else {
        _axios2.default.post(this.submit_url, { items: this.selectedItems }).then(function (res) {
          if (res.data.status == "ok") {
            _sweetalert2.default.fire({
              position: "top-end",
              icon: "success",
              title: "Successful request",
              text: "The items have been queued for settlement. Please check again later.",
              timer: 3000
            }).then(function () {
              location.reload();
            });
          } else {
            _sweetalert2.default.fire({
              position: "top-end",
              icon: "error",
              title: "Error processing request",
              text: "Your request cannot be processed at the moment.",
              timer: 4000
            });
          }
        });
      }
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card",attrs:{"data-toggle":"lists"}},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group mb-0 col-sm-6"},[_c('select2',{on:{"change":_vm.fetchSettlementItems},model:{value:(_vm.merchant_id),callback:function ($$v) {_vm.merchant_id=$$v},expression:"merchant_id"}},[_c('option',{domProps:{"value":null}},[_vm._v("Select Merchant...")]),_vm._v(" "),_vm._l((_vm.merchantList),function(merchant){return _c('option',{key:merchant.id,domProps:{"value":merchant.id}},[_vm._v("\n              "+_vm._s(merchant.name)+"\n            ")])})],2)],1),_vm._v(" "),_c('div',{staticClass:"form-group mb-0 col-sm-3"},[_c('date-picker',{attrs:{"format":"YYYY-MM-DD HH:mm:ss","confirm":true,"range-separator":"-","value-type":"format","placeholder":"Select date","lang":"en","type":"datetime","input-class":"form-control datePicker","append_to_body":true,"range":true,"shortcuts":false},on:{"clear":_vm.applyFilter,"change":_vm.fetchSettlementItems},model:{value:(_vm.date_range),callback:function ($$v) {_vm.date_range=$$v},expression:"date_range"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedItems && _vm.selectedItems.length),expression:"selectedItems && selectedItems.length"}],staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-outline-primary lift btn-block",on:{"click":_vm.processSettlement}},[_vm._v("\n            Process Settlement\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm table-hover table-nowrap card-table"},[_c('thead',[_c('tr',[_c('th',{directives:[{name:"show",rawName:"v-show",value:(_vm.pendingItems && _vm.pendingItems.length),expression:"pendingItems && pendingItems.length"}]},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isCheckAll),expression:"isCheckAll"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isCheckAll)?_vm._i(_vm.isCheckAll,null)>-1:(_vm.isCheckAll)},on:{"click":_vm.checkAll,"change":function($event){var $$a=_vm.isCheckAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isCheckAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isCheckAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isCheckAll=$$c}}}}),_vm._v(" "),_c('label',[_vm._v(" Select All")])]),_vm._v(" "),_c('th',{staticClass:"text-muted"},[_vm._v("ID")]),_vm._v(" "),_c('th',{staticClass:"text-muted"},[_vm._v("Client Invoice Ref")]),_vm._v(" "),_c('th',{staticClass:"text-muted"},[_vm._v("Currency")]),_vm._v(" "),_c('th',{staticClass:"text-muted"},[_vm._v("Amount Paid")]),_vm._v(" "),_c('th',{staticClass:"text-muted"},[_vm._v("Paid At")]),_vm._v(" "),_c('th',{staticClass:"text-muted"},[_vm._v("Status")])])]),_vm._v(" "),(_vm.pendingItems && _vm.pendingItems.length)?_c('tbody',_vm._l((_vm.pendingItems),function(item){return _c('tr',{key:item.id},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedItems),expression:"selectedItems"}],attrs:{"type":"checkbox"},domProps:{"value":item,"checked":Array.isArray(_vm.selectedItems)?_vm._i(_vm.selectedItems,item)>-1:(_vm.selectedItems)},on:{"change":[function($event){var $$a=_vm.selectedItems,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedItems=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedItems=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedItems=$$c}},_vm.updateCheckAll]}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.id)+".")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.invoice_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.currency))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.amount_paid))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.inserted_at))]),_vm._v(" "),(item.status == 'settled')?_c('td',[_c('span',{staticClass:"badge badge-pill badge-success"},[_c('i',{staticClass:"fa fa-check-circle",attrs:{"aria-hidden":"true"}}),_vm._v("\n                "+_vm._s(item.status)+"\n              ")])]):_vm._e()])})):_c('tbody',[_vm._m(0)])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"text-muted"},[_c('i',[_vm._v("Nothing to show...")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])}]
__vue__options__._scopeId = "data-v-50fccb98"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-50fccb98", __vue__options__)
  } else {
    hotAPI.reload("data-v-50fccb98", __vue__options__)
  }
})()}